var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('div',{staticClass:"title"},[_vm._v("Customer info")])])],1)],1),_c('v-card-text',[_c('v-divider',{staticClass:"pb-6"}),_c('customer-create-edit-form',{on:{"cancelled":function($event){return _vm.$router.push({
          name: 'customer',
          params: { customer_id: _vm.customer.id }
        })}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }